import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import InvoiceSelect from '../../../components/form/InvoiceSelect';

function CreditNoteListPageActions({ actions }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleAction = (action) => {
    if (action.action === 'create' && !checkSubscription()) {
      return;
    }

    switch (action.action) {
      case 'create':
        setOpen(true);
        setAction(action);
        break;
      default:
        console.log('Unknown action');
    }
  };

  const handleClose = () => {
    setOpen(false);
    setAction(null);
  };

  const handleContinue = () => {
    if (selectedInvoice) {
      navigate('/documents/credit-notes/create', { state: { invoiceData: selectedInvoice } });
    }
  };

  return (
    <>
      {actions.map((action, index) => (
        <Button
          id="create-credit-note"
          key={index}
          variant="contained"
          color="primary"
          onClick={() => handleAction(action)}
        >
          + Create Credit Note
        </Button>
      ))}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Select Invoice</DialogTitle>
        <Divider />
        <DialogContent>Select an invoice from the dropdown to continue.</DialogContent>
        <DialogContent>
          <InvoiceSelect name="select-invoice" onSelect={setSelectedInvoice} document_type={'01'} />
        </DialogContent>
        <DialogActions>
          <Button id="credit-note-cancel" onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button id="credit-note-continue" onClick={handleContinue} variant="contained" disabled={!selectedInvoice}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      <SubscriptionModal />
    </>
  );
}

export default CreditNoteListPageActions;
